import { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import { getProduct } from 'redux/products/actions';
import { getProductBySlug } from 'redux/products/reducers';

// eslint-disable-next-line import/no-cycle
import AddToCart from './components/AddToCart';

class BuyButtonProduct extends Component {
  componentDidMount() {
    this.getProduct();
  }

  getProduct = () => {
    const { props } = this;
    const { slug } = this.props;
    props.getProduct(slug);
  };

  render() {
    const { settings, product, node } = this.props;
    if (!settings.data || !product) {
      return null;
    }
    const analytics = {
      viewType: 'Buy Button'
    };
    return ReactDOM.createPortal(
      <>
        <AddToCart
          key={product.id}
          product={product}
          settings={settings}
          analytics={analytics}
        />
      </>,
      node
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  product: getProductBySlug(state.product, ownProps.slug),
  settings: state.setting
});

export default connect(mapStateToProps, {
  getProduct
})(BuyButtonProduct);
